// extracted by mini-css-extract-plugin
export default {"mainDiv":"styles_mainDiv__F6ivL","cardDiv":"styles_cardDiv__tgdLw","cardStyle":"styles_cardStyle__8GZgt","cardText":"styles_cardText__Q0t5c","warningImg":"styles_warningImg__0dgpM"};